import { observable, action } from "mobx";
import { createContext } from "react";
import agent from "../api/agent";
import { ILoginResponse } from "../models/loginresponse";
import { IUser } from "../models/user";

//
import Axios, { AxiosResponse } from 'axios'
import config from '../../app/api/apiconfig';
const integtokenUrl = config.app.integtokenUrl
const getusrauthbaseUrl = config.app.getusrauthbaseUrl

class UserAuthStore {
  @observable LoggedInObj: ILoginResponse | undefined = undefined;
  @observable loggedInUser: IUser | undefined = undefined;
  @observable authMessage = "";
  @observable currentModule = "Home";
  @observable isLoggedIn = false;
  @observable isLoggingIn = false;

  @action SetFunctionMode = (func: string) => {
    this.currentModule = func;
    sessionStorage.setItem("module",func)
  };

//Used to handle refreshes where the state is lost, update state from sessionsstorate
@action HydrateAuthState = () =>{
  if (sessionStorage.getItem("isLoggedIn") === "true")
  {
    this.isLoggedIn = true;
    this.LoggedInObj = JSON.parse(sessionStorage.getItem("sessionObj")!);
  }
  else
  {
   // window.location.assign("/login");
  }
}

  @action SetLogin = (resp: ILoginResponse) => {
    if (resp.Client !== null) {
      let validToken = getintegtoken();

      sessionStorage.setItem("isLoggedIn", "true");
      sessionStorage.setItem("sessionObj", JSON.stringify(resp));

      this.loggedInUser = resp.User;
      this.isLoggedIn = true;
      this.LoggedInObj = resp;
      this.isLoggingIn = false;
    } else {
      this.isLoggingIn = false;
      this.LoggedInObj = undefined;
      this.loggedInUser = undefined;
      this.authMessage = "Incorrect Login Details, Please Try Again";
    }
  };

  @action SetLogout = () => {
    sessionStorage.clear();
    this.LoggedInObj = undefined;
    this.currentModule = "";
    this.isLoggedIn = false;
    window.location.hash = "/";
  };

  @action LoginUser = (user: string, pass: string) => {
    this.isLoggingIn = true;
    agent.UserAuth.Login({
      source: "Client Portal Login",
      username: user,
      password: pass,
      timestamp: new Date()
    })
      .then(resp => this.SetLogin(resp))
      .catch(error => {
        alert("Error Logging In: " + error);
        this.isLoggingIn = false;
      });
  };
}

//ADD221031 - for the method to get dyna token (cxintegration)
function getintegtoken(){
  let validToken = ""
    Axios.get(integtokenUrl).then(response => {
        if(response.status === 200){
          var responsedata = response.data;
          if (responsedata != null && responsedata.length > 9) {
            validToken = responsedata
            sessionStorage.setItem('token', responsedata)
            return responsedata;
          }
        }
    });
  }

//Create new store in react context
export default createContext(new UserAuthStore());
